import api from '@/services/api';
import type {
    ApiItemResponse,
    ApiListResponse,
    CreateDealerBankAccountPayload,
    DealerBankAccount,
    UpdateDealerBankAccountPayload,
} from '../types/dealers.types';

const dealerBankAccountsPath = (dealerId: string): string => `/dealers/${dealerId}/bank-accounts`;

export const fetchDealerBankAccounts = async (dealerId: string): Promise<DealerBankAccount[]> => {
    const response = await api.get<ApiListResponse<DealerBankAccount>>(`${dealerBankAccountsPath(dealerId)}`);

    if (!response.data.success) {
        throw new Error('Failed to fetch dealer bank accounts');
    }

    return response.data.data;
};

export const createDealerBankAccount = async (
    dealerId: string,
    payload: CreateDealerBankAccountPayload
): Promise<DealerBankAccount> => {
    const response = await api.post<ApiItemResponse<DealerBankAccount>>(`${dealerBankAccountsPath(dealerId)}`, payload);

    if (!response.data.success) {
        throw new Error('Failed to create dealer bank account');
    }

    return response.data.data;
};

export const updateDealerBankAccount = async (
    dealerId: string,
    bankAccountId: string,
    payload: UpdateDealerBankAccountPayload
): Promise<DealerBankAccount> => {
    const response = await api.put<ApiItemResponse<DealerBankAccount>>(
        `${dealerBankAccountsPath(dealerId)}/${bankAccountId}`,
        payload
    );

    if (!response.data.success) {
        throw new Error('Failed to update dealer bank account');
    }

    return response.data.data;
};

export const deleteDealerBankAccount = async (dealerId: string, bankAccountId: string): Promise<void> => {
    const response = await api.delete<ApiItemResponse<null>>(`${dealerBankAccountsPath(dealerId)}/${bankAccountId}`);

    if (!response.data.success) {
        throw new Error('Failed to delete dealer bank account');
    }
};
